/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as vscode from 'vscode';
import { $9hc } from '../configuration/fileSchemes';
import { $Shc } from '../configuration/languageDescription';
import { $Nhc } from '../configuration/languageIds';
import { $whc } from '../utils/dispose';
import { $$jc } from './activeJsTsEditorTracker';

/**E
 * When clause context set when the current file is managed by vscode's built-in typescript extension.
 */
export default class $qkc extends $whc {
	private static readonly a = 'typescript.isManagedFile';

	private b: boolean = false;

	public constructor(activeJsTsEditorTracker: $$jc) {
		super();
		activeJsTsEditorTracker.onDidChangeActiveJsTsEditor(this.e, this, this.d);

		this.e(activeJsTsEditorTracker.activeJsTsEditor);
	}

	private e(editor?: vscode.TextEditor): void {
		if (editor) {
			this.f(this.i(editor));
		} else {
			this.f(false);
		}
	}

	private f(newValue: boolean) {
		if (newValue === this.b) {
			return;
		}

		vscode.commands.executeCommand('setContext', $qkc.a, newValue);
		this.b = newValue;
	}

	private i(editor: vscode.TextEditor): boolean {
		return this.j(editor) || this.k(editor);
	}

	private j(editor: vscode.TextEditor): boolean {
		return $Nhc(editor.document) && !$9hc.has(editor.document.uri.scheme);
	}

	private k(editor: vscode.TextEditor): boolean {
		return $Shc(editor.document.fileName);
	}
}

